import { render, staticRenderFns } from "./RoleReportQermission.vue?vue&type=template&id=abe5318a&scoped=true&"
import script from "./RoleReportQermission.vue?vue&type=script&lang=js&"
export * from "./RoleReportQermission.vue?vue&type=script&lang=js&"
import style0 from "./RoleReportQermission.vue?vue&type=style&index=0&id=abe5318a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe5318a",
  null
  
)

export default component.exports